var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "h3",
    _vm._g(
      _vm._b({ staticClass: "card-title" }, "h3", _vm.data.attrs, false),
      _vm.listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }